import { render, staticRenderFns } from "./DeleteDestroyVm.vue?vue&type=template&id=5396db7e&scoped=true"
import script from "./DeleteDestroyVm.vue?vue&type=script&lang=js"
export * from "./DeleteDestroyVm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5396db7e",
  null
  
)

export default component.exports